<template>
    <PasswortVergessenStage1 v-if="!user" :sessionId="sessionId" @updateSessionId="updateSessionId" ></PasswortVergessenStage1>
    <PasswortVergessenStage2 v-if="user && user.benutzername" :benutzername="user.benutzername" :sessionId="sessionId" @updateSessionId="updateSessionId" ></PasswortVergessenStage2>
</template>

<script lang="ts">
    import { extractAttrs } from '@/services/extract-attrs';
    import { defineComponent } from 'vue';
    import PasswortVergessenStage1 from './PasswortVergessenStage1.vue';
    import PasswortVergessenStage2 from './PasswortVergessenStage2.vue';
    import ApiService from '@/services/apiService';
import { getFormHashString } from '@/services/formSession.ts';

    const PasswortVergessenForm = defineComponent({
        name: "PasswortVergessenForm",
        data() {
            return {
                sessionId: "",
                user: null as { benutzername: string } | null,
                paramUserKey: null as string | null,
                paramRandomKey: null as string | null,
                auftragsGuid: null as string | null,
                viewData: {} as any,

            }
        },
        props: {
            container: HTMLElement
        },
        async beforeMount() {
            const attrs = extractAttrs(this.container!);
            const session = attrs["session"];
            this.sessionId = session;
            const urlParams = new URL(window.location.toString()).searchParams;
            this.paramUserKey = urlParams.has("u") ? urlParams.get("u") : null;
            this.paramRandomKey = urlParams.has("r") ? urlParams.get("r") : null;
            this.auftragsGuid = urlParams.has("l") ? urlParams.get("l") : null;

            this.user = await this.CheckMailVerifizierung();
        },
        methods: {
            async CheckMailVerifizierung() {
                if (!this.paramUserKey || !this.paramRandomKey) {
                    return null;
                }
                const params = { userKey: this.paramUserKey, randomKey: this.paramRandomKey, sessionId: getFormHashString(this.sessionId) };
                this.viewData = await ApiService.Instance.PostData("/umbraco/login/ZugangsdatenVergessenForm/CheckMailVerifizierung", params);

                if (this.viewData.redirectTo) {
                    window.location.href = this.viewData.redirectTo;
                }

                if (this.viewData.sessionId)
                    this.sessionId = this.viewData.sessionId;

                return this.viewData.user ? this.viewData.user : { benutzername: "" };
            },
            updateSessionId(newSessionId: string) {
                this.sessionId = newSessionId;
            }
        },
        components:
            { PasswortVergessenStage1, PasswortVergessenStage2 }
        ,


    });
    export default PasswortVergessenForm;
</script>